// Server response model
import SiteModel from '@/Models/SiteModel';
import { Group } from '@/Models/Shared/Group';

export interface UserAPIModel {
    ID: number;
    IsAdmin: boolean;
    DefaultTranscriptionOnly?: boolean;
    FullName: string;
    FilterOutDefaultRadiologistFromMyReports: boolean;
    IsAssistantRadiologist: boolean;
    RadiologistID?: number;
    ShowEchoFromStarted: boolean;
    ShowToJustify: boolean;
    ShowToControl: boolean;
    DaysInFutureToJustify?: number;
    StartTimingFrom: any; // StatusModel
    StopTimingAt: any; // StatusModel
    LoggedOnSite_UID?: number;
    FullUsername: string;
    Name: string;
    Username: string;
    RestrictRoomsToCurrentSite: boolean;
    RoomsInWorklist: number[];
    DisplayLength: number;
    Group: Group;
    Group_UID: number;
    UserTemplate: boolean;
    SiteModel: SiteModel;
    UserReportDefaultStatuses: any; // UserReportDefaultStatuses
    HideOrdersWithoutLinkedDocs: boolean;
    WorklistPreferences: any; // WorklistPreferences
    ShowIndicatorUserRadiologistProcedure: boolean;
    ShowReadEIDButton: boolean;
    PACSDrivenURL: string;
    DisplayLanguage: string | null;
    PreferredPrinter: string;
    PreferredScanner: string;
    Active: boolean;
    Permissions: Permissions;
}

export interface Permissions {
    CanEditUserDefaults: boolean;
    CanCreateAndEditReport: boolean;
    CanDeleteOrders: boolean;
    CanSeeInvoiceTab: boolean;
}

// React models
export interface UserModel {
    admin: boolean;
    canEditUserDefaults: boolean;
    canCreateAndEditReport: boolean;
    daysInFutureToJustify?: number;
    DisplayLanguage: string | null;
    fullName: string;
    fullUsername: string;
    groupID: number;
    ID: number;
    loggedOnSite_UID?: number;
    PACSDrivenURL: string;
    PreferredPrinter: string;
    PreferredScanner: string;
    showEchoFromStarted: boolean;
    showReadEIDButton: boolean;
    showToControl: boolean;
    showToJustify: boolean;
    siteModel: SiteModel;
    username: string;
}

export function userLoadedMapper(model: UserAPIModel): UserModel {
    const user: UserModel = {
        admin: model.IsAdmin,
        canEditUserDefaults: model.Permissions.CanEditUserDefaults,
        canCreateAndEditReport: model.Permissions.CanCreateAndEditReport,
        daysInFutureToJustify: model.DaysInFutureToJustify,
        DisplayLanguage: model.DisplayLanguage,
        fullName: model.FullName,
        fullUsername: model.FullUsername,
        groupID: model.Group_UID,
        ID: model.ID,
        loggedOnSite_UID: model.LoggedOnSite_UID,
        PACSDrivenURL: model.PACSDrivenURL,
        PreferredPrinter: model.PreferredPrinter,
        PreferredScanner: model.PreferredScanner,
        showEchoFromStarted: model.ShowEchoFromStarted,
        showReadEIDButton: model.ShowReadEIDButton,
        showToControl: model.ShowToControl,
        showToJustify: model.ShowToJustify,
        siteModel: model.SiteModel,
        username: model.Username,
    };
    return user;
}
